import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const HeaderStyles = styled.div`
	text-align: center;
	margin-bottom: 16px;
	margin-top: 8px;

	.header__hed {
		font-size: 48px;
		font-family: "Miller";
		font-weight: 400;
		text-align: left;
		line-height: 1;
		margin-left: 24px;
		margin-right: 24px;
		color: #000;
	}

	.header__link {
		text-decoration: none;
	}

	.header__subhed {
		font-size: 18px;
		font-weight: 400;
	}

	@media (max-width: 768px) {
		// width: 90%;
	    // margin: 0 auto;
	    margin-bottom: 24px;

	    .header__hed {
	      text-align: center;
	      max-width: 480px;
	      margin: 0 auto;
	    }
	}

	@media (max-width: 480px) {
		.header__hed {
			max-width: 360px;
		}
	}

	@media (max-width: 400px) {
		.header__hed {
			font-size: 40px;
		}
	}
`;

const Header = () => {
  return (
    <HeaderStyles>
      <Link to="/" className="header__link"><h1 className="header__hed">How do we memorialize the pandemic?</h1></Link>
    </HeaderStyles>
  );
};

export default Header;
